import { render, staticRenderFns } from "./IcoArrowInDownRectangle.vue?vue&type=template&id=05479064"
import script from "./IcoArrowInDownRectangle.vue?vue&type=script&lang=js"
export * from "./IcoArrowInDownRectangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports